import { render, staticRenderFns } from "./OrgSelector.vue?vue&type=template&id=5c02e4ed&scoped=true&"
import script from "./OrgSelector.vue?vue&type=script&lang=js&"
export * from "./OrgSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02e4ed",
  null
  
)

export default component.exports